var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"app-btn ml-2",class:{ blue: _vm.blue, red: _vm.red, green: _vm.green, gray: _vm.gray },style:(_vm.style),attrs:{"type":"button"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47732f18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/app-button.vue
// module id = 659
// module chunks = 49